import { MessageCircle, ArrowRight, Phone, Clock } from "lucide-react";
import { buildWhatsAppUrl, trackEvent } from "@/lib/utm";

export default function FinalCTA() {
  const wa = buildWhatsAppUrl(
    "5218116289267",
    "Hola Eclipse, me interesa agendar una cotizacion de FlexShade."
  );
  return (
    <section className="relative py-24 md:py-32 overflow-hidden bg-black text-white">
      <img
        src="/images/brochure_img_p6_1.jpeg"
        alt="Proyecto FlexShade"
        className="absolute inset-0 w-full h-full object-cover opacity-30"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/70" />
      <div className="relative container-x text-center">
        <span className="eyebrow bg-orange-500/10 border-orange-500/30" style={{color: '#fdba74'}}>Último paso</span>
        <h2 className="mt-5 section-title text-5xl md:text-7xl lg:text-8xl font-black max-w-4xl mx-auto">
          Tu espacio merece <span className="text-orange-500">protección real</span>
        </h2>
        <p className="mt-6 text-white/75 text-lg md:text-xl max-w-2xl mx-auto">
          20 años instalando techos en el norte de México. Cotización gratuita en 24 horas. Sin compromiso.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={wa}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackEvent("whatsapp_click", { location: "final_cta" })}
            className="btn-wa px-7 py-4 rounded-xl inline-flex items-center justify-center gap-2 text-base md:text-lg"
          >
            <MessageCircle className="w-5 h-5" /> Cotiza por WhatsApp
          </a>
          <a href="#cotizar" className="btn-outline-light px-7 py-4 rounded-xl inline-flex items-center justify-center gap-2 text-base">
            Llenar formulario <ArrowRight className="w-5 h-5" />
          </a>
        </div>

        <div className="mt-10 flex flex-col md:flex-row items-center justify-center gap-5 md:gap-10 text-white/75 text-sm">
          <a
            href="tel:+528189899822"
            className="flex items-center gap-2 hover:text-white"
            onClick={() => trackEvent("phone_click", { location: "final_cta" })}
            data-testid="final-cta-call"
          >
            <Phone className="w-4 h-4 text-orange-500" /> Llámanos hoy mismo
          </a>
          <span className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-orange-500" /> Lun-Vie 9:00-18:00 hrs
          </span>
          <span className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
            Respuesta en menos de 24 hrs
          </span>
        </div>
      </div>
    </section>
  );
}
